import React, { type ReactNode } from 'react';
import { cn } from '../../src/lib/utils';
export const TOTAL_SLIDES = 16;
type SlideProps = {
  children: ReactNode;
  /** 1-based slide number shown in the footer chrome. */
  index: number;
  /** Discreet source / methodology note for any external statistics. */
  source?: string;
  /** `deep` is the near-black cover / closing treatment. */
  variant?: 'default' | 'deep';
  className?: string;
};

/**
 * Full-bleed 16:9 institutional slide shell. Owns the midnight canvas, the
 * safe-area margins and the persistent brand + page chrome so every slide
 * shares one visual system.
 */
export function Slide({
  children,
  index,
  source,
  variant = 'default',
  className
}: SlideProps) {
  return <section className={cn('relative flex h-full w-full flex-col overflow-hidden text-[#EEF2F9]', variant === 'deep' ? 'bg-[#04060C]' : 'bg-[#070B14]')} style={{
    fontFamily: 'var(--font-sans)'
  }} data-id="element-16" data-mp="122a8375sr4ct">
      {/* Fine institutional grid — meaningful structure, not decoration. */}
      <div aria-hidden className="pointer-events-none absolute inset-0 opacity-[0.55]" style={{
      backgroundImage: 'linear-gradient(to right, rgba(255,255,255,0.035) 1px, transparent 1px), linear-gradient(to bottom, rgba(255,255,255,0.035) 1px, transparent 1px)',
      backgroundSize: '6.25% 11.11%'
    }} data-id="element-17" data-mp="2kv72kxtw9oa4" />

      <div className={cn('relative flex min-h-0 w-full flex-1 flex-col px-[5.5%] pb-[3vh] pt-[6vh]', className)} data-id="element-18" data-mp="21a2k20ol568o">
        {children}
      </div>

      <div className="relative mx-[5.5%] mb-[3.2vh] flex items-center justify-between border-t border-white/10 pt-[1.6vh]" data-id="element-19" data-mp="2az43k0uca5re">
        <span className="text-[clamp(7px,0.72vw,15px)] uppercase tracking-[0.28em] text-white/35" data-id="element-20" data-mp="266kot0jx14l0">
          StartupFuel · DiligenceGPT™
        </span>
        {source ? <span className="mx-[2vw] flex-1 truncate text-center text-[clamp(6.5px,0.66vw,14px)] text-white/25" data-id="element-21" data-mp="1dk86ti0ctfnw">
            {source}
          </span> : <span className="flex-1" data-id="element-22" data-mp="3ikstdo4yy6sr" />}
        <span className="text-[clamp(7px,0.72vw,15px)] tracking-[0.28em] text-white/35" data-id="element-23" data-mp="3ijhrxuyzxb4t">
          {String(index).padStart(2, '0')} / {TOTAL_SLIDES}
        </span>
      </div>
    </section>;
}